import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Box} from '@mui/material';

import FormTitle from 'components/form/FormTitle';
import FormSubtitle from "components/form/FormSubtitle";

FormBloc.propTypes = {
    titleId: PropTypes.string.isRequired,
    subtitleId: PropTypes.string,
    rightElement: PropTypes.node,
};

function FormBloc({titleId, subtitleId, rightElement, ...props}) {
    return (
        <Grid item xs={12}>
            <Grid container rowSpacing={4}>
                <Grid item xs={12}>
                    <Box display="flex" alignItems="center" gap="8px">
                        <FormTitle titleId={titleId} />
                        {rightElement}
                    </Box>
                    {subtitleId && <FormSubtitle subtitleId={subtitleId} />}
                </Grid>
                <Grid item xs={12}>
                    {props.children}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default FormBloc;
